import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../GuideDetails.css";
import { scroller } from "react-scroll";
import BookingForm from "../BookingForm";
import Footer from "../Footer";
import tourImg1 from "../../assets/walking/1.jpg";
import tourImg2 from "../../assets/walking/2 walking.jpg";
import tourImg3 from "../../assets/walking/5.jpg";
import tourImg4 from "../../assets/walking/4.jpg";
import tourImg5 from "../../assets/walking/5 walking.jpg";
import tourImg6 from "../../assets/walking/6.jpg";
import tourImg7 from "../../assets/walking/9.jpg";
import tourImg8 from "../../assets/walking/8 walking.jpg";
import tourImg9 from "../../assets/walking/9 walking.jpg";
import tourImg10 from "../../assets/walking/10.jpg";
import tourImg11 from "../../assets/walking/free.jpg";
import tourImg12 from "../../assets/walking/free1.jpg";

export default function FreeWalkingTour() {
  const bookingRef = useRef(null);
  const navigate = useNavigate();
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Original images array
  const images = [
    tourImg1, tourImg2, tourImg3, tourImg4, tourImg5, tourImg6, 
    tourImg7, tourImg8, tourImg9, tourImg10, tourImg11, tourImg12 
   
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Scroll BookingForm to center of viewport
const scrollToBooking = () => {
  if (bookingRef.current) {
    const topOffset = 80; // height of your navbar in px
    const elementPosition = bookingRef.current.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - topOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
};

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const prevImage = (e) => {
    e.stopPropagation(); // prevent closing
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="guide-page">

{/* Back Button */}
<button
  className="back-button"
  onClick={() => {
    // Navigate to home first
    navigate("/", { replace: false });

    // Then scroll after a tiny delay
    setTimeout(() => {
      scroller.scrollTo("tours", {
        smooth: true,
        offset: -70, // height of navbar
        duration: 500,
      });
    }, 100);
  }}
>
  ← Back to Tours
</button>

      <div className="guide-container">
        <div className="guide-left">
           <div class="tour-description">
              <h1 class="tour-intro">Tour Overview</h1>

              <p style={{fontSize: '20px'}}>
                Discover the magic of Gjirokaster on our 2-hour Free Walking Tour, led by certified local guides who bring the city’s history and stories to life.
              </p>

              <p style={{fontSize: '20px'}}>
                This experience takes you through the most fascinating parts of the historic center, where stone houses, narrow cobblestone streets, and panoramic views create the unique atmosphere that makes Gjirokaster a UNESCO-listed treasure.
              </p>

              <h2 class="tour-subtitle">Why Join Our Free Walking Tour?</h2>

              <ul style={{fontSize: '20px'}}>
                <li>Certified local guides</li>
                <li>Deep historical and cultural insight</li>
                <li>Authentic local stories</li>
                <li>The best photo viewpoints in town</li>
                <li>A friendly, interactive experience</li>
              </ul>
              <p style={{ fontSize: '20px'}}>
                Whether it’s your first time in Gjirokaster or you want to understand the city beyond the surface, this tour is the perfect introduction to its history, architecture and daily life.
              </p>
            </div>
        </div>

        <div className="guide-right">
          <div className="guide-modal">
            <h2 className="tour-overview-heading">What we’ll See</h2>
            <ul style={{fontSize: '19px'}}>
              <p style={{textAlign: 'center', fontSize:'20px'}}>On this tour, we explore the key landmarks of the historic center, including: </p>
              <li>The historic Old Bazaar</li>
              <li>The Obelisk Monument</li>
              <li>The Bazaar Mosque</li>
              <li>Beautiful examples of Gjirokastra-style houses</li>
              <li>The 300-year-old Skenduli House</li>
              <li>The former home of Enver Hoxha, today the Ethnographic Museum</li>
              <li>The birthplace of Albania’s most celebrated writer, Ismail Kadare</li>
              <li>Cold War Communist Tunnels</li>
              <li>We finish near the castle, giving you the opportunity to explore it right after the tour independently if you wish.</li>

            </ul>

            <h3 style={{textAlign: 'center'}}>Tour Information</h3>
            <p>
              <strong>Schedule:</strong> Daily at 10:00 AM, 1:30 PM & 6:00 PM (May to September)<br />
              <span class="time-second-line">
                Daily 10:00 AM & 5:00 PM for March, April, October
              </span>
            </p>
            <p><strong>Duration: </strong>About 2 hours</p>
            <p><strong>Meeting Point:</strong> Rruga Zejtareve (To the left of Rrapi Restaurant)</p>
            
            <p><strong>Group Size:</strong> Up to 15 people</p>
            <p><strong>Price:</strong> Tip‑based (you pay what you think the tour was worth)</p>

            <button className="book-button" onClick={scrollToBooking}>
              Book This Tour
            </button>
          </div>
        </div>
      </div>

<h1 className="tour-overview-heading">Tour gallery</h1>
<div className="photo-gallery">
  {images.map((img, index) => (
    <img
      key={index}
      src={img}
      alt={`Berat ${index + 1}`}
      loading="lazy"   // <-- lazy load each image
      onClick={() => openLightbox(index)}
    />
  ))}
</div>
      {/* Lightbox with Next / Previous Buttons */}
      {lightboxOpen && (
        <div className="lightbox" onClick={() => setLightboxOpen(false)}>
          <img src={images[currentIndex]} alt={`Preview ${currentIndex}`} />
          <button className="prev-btn" onClick={prevImage}>‹</button>
          <button className="next-btn" onClick={nextImage}>›</button>
        </div>
      )}

      <div ref={bookingRef}>
        <BookingForm />
        <Footer />
      </div>
    </div>
  );
}
